import { render } from "./WPNotificationBox.vue?vue&type=template&id=796b64bc"
import script from "./WPNotificationBox.vue?vue&type=script&lang=js"
export * from "./WPNotificationBox.vue?vue&type=script&lang=js"

import "./WPNotificationBox.vue?vue&type=style&index=0&id=796b64bc&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__